
/**
 * SEO 配置 - models (Bahasa Indonesia)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Generator Video AI Fisika-Akurat | WeryAI',
        description: 'Hasilkan video AI yang realistis dan akurat secara fisik menggunakan OpenAI Sora 2 dengan audio tersinkronisasi dan konsistensi narasi multi-shot.',
        keywords: 'Sora 2, OpenAI Sora, model video AI, video AI realistis, teks ke video, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2 - Generator Gambar AI Asli | WeryAI',
        description: 'Gunakan WeryAI Image 2 untuk generasi gambar AI asli yang menakjubkan! Model unggulan dengan kontrol gaya canggih. Kredit gratis, tanpa kartu.',
        keywords: 'WeryAI Image 2, generator gambar AI asli, gambar AI unggulan, kualitas studio AI, WeryAI Image gratis, cara menggunakan WeryAI Image 2, WeryAI',
    },
    image_grok_2: {
        title: 'Gratis Grok 2 - Generator Gambar xAI | WeryAI',
        description: 'Gunakan Grok 2 di WeryAI untuk menghasilkan gambar AI kreatif! Model xAI dengan fleksibilitas artistik dan gaya visual unik. Kredit gratis, tanpa kartu.',
        keywords: 'Grok 2, Grok AI, generator gambar xAI, seni AI, gambar AI kreatif, Grok 2 gratis, cara menggunakan Grok 2, WeryAI',
    },
    image_nano_banana_2: {
        title: 'Nano Banana 2 Generator Gambar | WeryAI',
        description: 'Nano Banana 2 didukung oleh Gemini dengan pengetahuan dunia dan pencarian real-time. Hasilkan gambar yang akurat secara faktual dan memukau dengan kecepatan ultra-cepat.',
        keywords: 'Nano Banana 2, Google AI, Gemini, pembuatan gambar, rendering teks, konsistensi multi-subjek, 4K, WeryAI',
        og_title: 'Generator Gambar Nano Banana 2 | WeryAI',
        og_description: 'Nano Banana 2 didukung oleh Gemini dengan pemahaman dunia yang mendalam dan pencarian waktu nyata, menghasilkan gambar yang indah dan akurat secara faktual.',
        twitter_title: 'Generator Gambar Nano Banana 2 | WeryAI',
        twitter_description: 'Nano Banana 2 didukung oleh Gemini dengan pemahaman dunia yang mendalam dan pencarian waktu nyata, menghasilkan gambar yang indah dan akurat secara faktual.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_ef98c0ea10c77d45e68553c1b6692e5b.webp',
        ogImageAlt: 'Generator gambar AI Nano Banana 2',
        twitterImageAlt: 'Generator gambar AI Nano Banana 2',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Generator Video AI Sinematik | WeryAI',
        description: 'Kling 2.5 Turbo membuat video AI sinematik berkualitas tinggi dengan kontrol lensa canggih, ekspresi emosional, dan gerakan halus.',
        keywords: 'Kling 2.5 Turbo, Kling AI, video AI sinematik, model AI perfilman, kontrol lensa AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - Generator & Editor Video AI Canggih | WeryAI',
        description: 'Runway Gen-4 menghasilkan video AI yang realistis dan konsisten dengan pemahaman prompt lebih dalam dan alat editing cerdas. Coba gratis di WeryAI.',
        keywords: 'Runway Gen-4, Runway AI, generator video AI, teks ke video, gambar ke video, editing video AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Generator Video AI Hailuo Pembuatan Video Tingkat | WeryAI',
        description: 'Hasilkan video AI tingkat lanjut dengan Hailuo AI di WeryAI. Menampilkan kontrol gerakan mutakhir dan rendering adegan yang realistis.',
        keywords: 'Hailuo AI, MiniMax, generator video AI, kontrol gerakan, video realistis, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Generator Video Seedance AI - Kreasi Tari & Gerakan | WeryAI',
        description: 'Generator Video Seedance AI - Kreasi Tari & Gerakan on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    seedance_2: {

        title: 'Werydance 2.0 - Generator Video AI Level Sutradara | WeryAI',

        description: 'Buat video AI level sutradara dengan Werydance 2.0: referensi multimodal, konsistensi naratif, dan simulasi fisika. Gratis di WeryAI.',

        keywords: 'Werydance 2.0, Seedance AI, weryai, generator video AI, video level sutradara, video multimodal, simulasi fisika, sinkronisasi bibir, teks ke video, video AI gratis, WeryAI',

        og_title: 'Werydance 2.0 - Generator Video AI Level Sutradara | WeryAI',

        og_description: 'Buat video AI level sutradara dengan Werydance 2.0: referensi multimodal, konsistensi naratif, dan simulasi fisika. Gratis di WeryAI.',

        twitter_title: 'Werydance 2.0 - Generator Video AI Level Sutradara | WeryAI',

        twitter_description: 'Buat video AI level sutradara dengan Werydance 2.0: referensi multimodal, konsistensi naratif, dan simulasi fisika. Gratis di WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Werydance 2.0 AI Video Generator',

        twitterImageAlt: 'Werydance 2.0 AI Video Generator',

    },
    image_nano_banana_pro: {
        title: 'Gratis Nano Banana Pro - Generator Gambar AI | WeryAI',
        description: 'Gunakan Nano Banana Pro di WeryAI untuk gambar AI kualitas tertinggi! Menyaingi Midjourney dalam kualitas. Kredit gratis, tanpa kartu.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, Google gambar AI, gambar AI reasoning, 4K gambar AI, Nano Banana Pro gratis, cara menggunakan Nano Banana Pro, WeryAI',
    },
    image_nano_banana: {
        title: 'Gratis Nano Banana - Generator Gambar AI | WeryAI',
        description: 'Gunakan Nano Banana di WeryAI untuk membuat gambar AI dengan mudah! Model AI serbaguna dan cepat. Kredit gratis, tanpa kartu.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, Google gambar AI, generator AI cepat, konsistensi karakter, Nano Banana gratis, cara menggunakan Nano Banana, WeryAI',
    },
    image_flux: {
        title: 'Gratis FLUX - Coba Generator Gambar AI | WeryAI',
        description: 'Gunakan FLUX di WeryAI untuk menghasilkan gambar AI yang menakjubkan! Dibuat oleh tim Stable Diffusion dengan kualitas visual luar biasa. Kredit gratis, tanpa kartu.',
        keywords: 'FLUX, FLUX AI, Black Forest Labs, generator gambar AI, teks ke gambar, seni AI, FLUX gratis, cara menggunakan FLUX, WeryAI',
    },
    image_flux_kontext: {
        title: 'Gratis FLUX Kontext - Editor Gambar AI Pro | WeryAI',
        description: 'Gunakan FLUX Kontext di WeryAI untuk editing gambar AI profesional! Ketepatan unggul, tipografi canggih, dan editing multi-langkah. Kredit gratis, tanpa kartu.',
        keywords: 'FLUX Kontext, FLUX.1 Kontext, editor gambar AI, gambar AI pro, tipografi AI, FLUX Kontext gratis, cara menggunakan FLUX Kontext, WeryAI',
    },
    image_imagen: {
        title: 'Gratis Imagen 4 - Generator Gambar AI Google | WeryAI',
        description: 'Gunakan Google Imagen 4 di WeryAI untuk membuat gambar AI fotorealistis! Kontrol gaya serbaguna dan generasi teks akurat. Kredit gratis, tanpa kartu.',
        keywords: 'Imagen 4, Google Imagen, generator gambar AI Google, teks ke gambar, AI fotorealistis, Imagen gratis, cara menggunakan Imagen 4, WeryAI',
    },
    image_qwen_image: {
        title: 'Gratis Qwen Image - Model Gambar AI Alibaba | WeryAI',
        description: 'Gunakan Qwen Image di WeryAI untuk seni AI multibahasa! Model open-source Alibaba dengan rendering teks unggul. Kredit gratis, tanpa kartu.',
        keywords: 'Qwen Image, Alibaba AI, gambar AI open-source, rendering teks multibahasa, Qwen Image gratis, cara menggunakan Qwen Image, WeryAI',
    },
    image_wan_ai: {
        title: 'Gratis Wan AI - Generator Gambar Alibaba | WeryAI',
        description: 'Gunakan Wan AI di WeryAI untuk gambar AI berkualitas tinggi! Model Alibaba dengan ketepatan prompt dan rendering fotorealistis. Kredit gratis, tanpa kartu.',
        keywords: 'Wan AI, Wan 2.5, generator gambar AI Alibaba, teks ke gambar, AI fotorealistis, Wan AI gratis, cara menggunakan Wan AI, WeryAI',
    },
    image_seendream: {
        title: 'Gratis Seedream 4.0 - ByteDance Gambar AI | WeryAI',
        description: 'Gunakan Seedream 4.0 di WeryAI untuk generasi gambar AI ultra cepat! Model ByteDance dengan gaya artistik beragam. Kredit gratis, tanpa kartu.',
        keywords: 'Seedream, Seedream 4.0, ByteDance gambar AI, gambar AI ultra cepat, gaya artistik AI, Seedream gratis, cara menggunakan Seedream, WeryAI',
    },
    image_dreamina: {
        title: 'Gratis Dreamina 4.0 - AI Gambar Multimodal | WeryAI',
        description: 'Gunakan Dreamina 4.0 di WeryAI untuk kreasi gambar AI multimodal! Sketsa ke gambar, transfer gaya, dan fusi karakter. Kredit gratis, tanpa kartu.',
        keywords: 'Dreamina 4.0, ByteDance gambar AI, gambar AI multimodal, sketsa ke gambar, transfer gaya, Dreamina gratis, cara menggunakan Dreamina 4.0, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Gratis Seedream 4.5 - ByteDance Gambar AI | WeryAI',
        description: 'Gunakan Seedream 4.5 di WeryAI untuk generasi gambar AI unggulan! Terbaru ByteDance dengan tipografi presisi. Kredit gratis, tanpa kartu.',
        keywords: 'Seedream 4.5, ByteDance gambar AI, model unggulan, rendering tipografi, fusi multi-gambar, Seedream 4.5 gratis, cara menggunakan Seedream 4.5, WeryAI',
    },
    image_seedream_5_0: {
        title: 'Seedream 5.0 Model Generasi Gambar AI Terbaik | WeryAI',
        description: 'Seedream 5.0 adalah mahakarya ByteDance di bidang AI visual dengan kualitas native 8K, pemahaman semantik tertinggi, komposisi multi-subjek, dan rendering teks 2.0. Coba gratis di WeryAI.',
        keywords: 'Seedream 5.0, generasi gambar AI, kualitas 8K, pemahaman semantik, komposisi multi-subjek, rendering teks, ByteDance, WeryAI',
        og_title: 'Generator Gambar Seedream 5.0 | WeryAI',
        og_description: 'Seedream 5.0 adalah mahakarya ByteDance dalam generasi visual AI dengan kualitas native 8K, pemahaman semantik tertinggi, komposisi multi-subjek, dan rendering teks yang lebih akurat.',
        twitter_title: 'Generator Gambar Seedream 5.0 | WeryAI',
        twitter_description: 'Seedream 5.0 adalah mahakarya ByteDance dalam generasi visual AI dengan kualitas native 8K, pemahaman semantik tertinggi, komposisi multi-subjek, dan rendering teks yang lebih akurat.',
        ogImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        twitterImage: 'https://static.weryai.com/growth/image/weryai_871e99f0d8f52b7abdb1d410e76ae64d.png',
        ogImageAlt: 'Generator gambar AI Seedream 5.0',
        twitterImageAlt: 'Generator gambar AI Seedream 5.0',
    },
    image_recraft_v4_vector: {
        title: 'Recraft V4 Vector - Generator Grafik Vektor AI Profesional | WeryAI',
        description: 'Recraft V4 Vector adalah generator grafik vektor AI profesional dari Recraft.ai yang menghasilkan vektor SVG yang dapat diedit dengan penskalaan tanpa kehilangan, tipografi presisi, dan kontrol gaya merek. Coba gratis di WeryAI sekarang.',
        keywords: 'Recraft V4 Vector, generasi vektor AI, generator SVG, vektor asli, desain logo, ikon UI, ilustrasi vektor, Recraft, WeryAI',
    },
    image_midjourney: {
        title: 'Gratis Midjourney - Coba Generator Seni AI | WeryAI',
        description: 'Gunakan Midjourney di WeryAI untuk membuat gambar AI artistik! Terkenal dengan estetika memukau dan kualitas pencahayaan. Kredit gratis, tanpa kartu.',
        keywords: 'Midjourney, Midjourney AI, generator seni AI, gambar AI artistik, Midjourney gratis, alternatif Midjourney, cara menggunakan Midjourney, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Generator Video AI | WeryAI',
        description: 'Buat video dari gambar dengan Runway Gen-4.5 di WeryAI. Unggah gambar, tambahkan prompt, dan hasilkan gerakan realistis dengan konsistensi fisika. Coba gratis.',
        keywords: 'Runway Gen-4.5, generator video AI, video AI sinematik, simulasi fisika, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Generator Video AI | WeryAI',
        description: 'Hasilkan video berkualitas tinggi dengan Kling 2.6 Pro di WeryAI. Generasi audiovisual native, kualitas sinematik 1080p, kepatuhan prompt yang sangat baik.',
        keywords: 'Kling 2.6 Pro, generator video AI, video AI berkualitas tinggi, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Generator Video Kontrol kamera presisi | WeryAI',
        description: 'Hasilkan video AI sinematik dengan Dreamina 3.0 (Jimeng 3.0) di WeryAI. Kontrol frame awal/akhir presisi, gerakan kamera profesional dan generasi video 1080p dinamis tinggi.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, generator video AI, kontrol kamera, frame awal akhir, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Generator Video AI Generasi Video Kreatif | WeryAI',
        description: 'Lepaskan kreativitas Anda di WeryAI dengan generator video AI Kling O1. Sempurna untuk menghasilkan konten video imajinatif dan unik.',
        keywords: 'Kling O1, generator video AI, video AI kreatif, Kling AI, WeryAI',
    },
    kling_3_0: {

        title: 'Kling 3.0 - Generator Video AI Cerdas | WeryAI',

        description: 'Buat video AI dengan Kling 3.0: storyboard cerdas, sinkronisasi bibir multibahasa, dan rendering teks presisi. Gratis di WeryAI.',

        keywords: 'Kling 3.0, Kling AI, Kuaishou, generator video AI, storyboard cerdas, sinkronisasi bibir, rendering teks, teks ke video, gambar ke video, video AI gratis, WeryAI',

        og_title: 'Kling 3.0 - Generator Video AI Cerdas | WeryAI',

        og_description: 'Buat video AI dengan Kling 3.0: storyboard cerdas, sinkronisasi bibir multibahasa, dan rendering teks presisi. Gratis di WeryAI.',

        twitter_title: 'Kling 3.0 - Generator Video AI Cerdas | WeryAI',

        twitter_description: 'Buat video AI dengan Kling 3.0: storyboard cerdas, sinkronisasi bibir multibahasa, dan rendering teks presisi. Gratis di WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Kling 3.0 AI Video Generator',

        twitterImageAlt: 'Kling 3.0 AI Video Generator',

    },
    vidu_q3: {

        title: 'Vidu Q3 - Generator Audio-Video AI Asli 16 Detik | WeryAI',

        description: 'Hasilkan audio-video asli 16 detik dengan Vidu Q3: potongan cerdas, rendering teks presisi, dan sinkronisasi bibir multibahasa. Gratis di WeryAI.',

        keywords: 'Vidu Q3, Vidu AI, generator video AI, audio-video asli 16 detik, storyboard cerdas, rendering teks, sinkronisasi bibir, teks ke video, gambar ke video, video AI gratis, WeryAI',

        og_title: 'Vidu Q3 - Generator Audio-Video AI Asli 16 Detik | WeryAI',

        og_description: 'Hasilkan audio-video asli 16 detik dengan Vidu Q3: potongan cerdas, rendering teks presisi, dan sinkronisasi bibir multibahasa. Gratis di WeryAI.',

        twitter_title: 'Vidu Q3 - Generator Audio-Video AI Asli 16 Detik | WeryAI',

        twitter_description: 'Hasilkan audio-video asli 16 detik dengan Vidu Q3: potongan cerdas, rendering teks presisi, dan sinkronisasi bibir multibahasa. Gratis di WeryAI.',



        ogImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        twitterImage: 'https://static.weryai.com/growth/image/weryai_94499d3ef8f300f8049d532a834bcc1c.png',

        ogImageAlt: 'Vidu Q3 AI Video Generator',

        twitterImageAlt: 'Vidu Q3 AI Video Generator',

    },
    image_gpt_4o: {
        title: 'Gratis GPT-4o - Generator Gambar OpenAI | WeryAI',
        description: 'Gunakan GPT-4o di WeryAI untuk membuat gambar melalui percakapan! AI OpenAI dengan rendering teks presisi dan hasil berkualitas tinggi. Kredit gratis, tanpa kartu.',
        keywords: 'GPT-4o, GPT-4o gambar, generator gambar OpenAI, seni AI percakapan, GPT-4o gratis, cara menggunakan GPT-4o gambar, WeryAI',
    },
    image_gpt_image_1_5: {
        title: 'Gratis GPT Image 1.5 - Generator Seni OpenAI | WeryAI',
        description: 'Gunakan GPT Image 1.5 di WeryAI untuk seni AI generasi terbaru! Model terbaru OpenAI dengan kreativitas dan detail yang ditingkatkan. Kredit gratis, tanpa kartu.',
        keywords: 'GPT Image 1.5, model gambar OpenAI, generator seni AI, AI generasi terbaru, GPT Image 1.5 gratis, cara menggunakan GPT Image 1.5, WeryAI',
    },
}
